import $ from 'jquery';
import 'popper.js';
import './min/015_bootstrap.min';
import './min/030_matchmedia';
import './min/040_ajaxInclude';
import './min/110-picturefill.min';

// Config init...
var _cfg = window['_config'] || {};

var cls = {
    log : function( _output ){
        if( app.debug ){
            console.log(_output);
        }
    }
};

var app = {
    debug: false,
    timeoutHandler: [],
    TWITTER: false,
    FACEBOOK: false,
    GPLUS: false,
    PINTEREST: false,

    DEVICE : '',

    //-> initialize function
    _init : function(){
        cls.log('-> _init');

        //set Device for AjaxInclude
        if( matchMedia('(max-width:767px)').matches ){
            app.DEVICE = 'mobile';
        }


    }
};
window.app = app || {};
app.modules || (app.modules = {});

(function () {
    var promise;

    app.loadParsley = function () {
        if (promise) {
            return promise;
        }

        promise = $.Deferred();

        import("./libs/parsley.min.js").then(function () {
            if (_cfg.lang && _cfg.lang !== 'en') {
                import("./libs/i18n/parsley/" + _cfg.lang + ".js").then(function () {
                    promise.resolve();
                }).catch(function () {
                    /*fallback if there is no package*/
                    promise.resolve();
                });
            } else {
                promise.resolve();
            }
        }).catch(function () {
            promise.reject();
        });

        return promise;
    };
}());

app.modules.popup = (function () {
    var $popupWindow = $('.js-popup');
    var $closeButton = $('.js-popup__close');
    var $popupOverlay = $('.js-popup__overlay');

    if(!sessionStorage.getItem('popup')) {
        $popupWindow.removeClass('hidden');
        $popupOverlay.removeClass('hidden');
    }

    $closeButton.click(function() {
        sessionStorage.setItem('popup', 'closed');
        $popupWindow.addClass("hidden");
        $popupOverlay.addClass("hidden");
    })
})

app.modules.ajaxInclude = (function () {
    function ajaxIncludeCallback() {
        var includedContainer = $(this).next();

        if ($(this).is('[data-target]')) {
            var targetContainer = $($(this).data('target'));
            if (targetContainer.length > 0) {
                includedContainer = targetContainer;
            }
        }

        app.initModules(includedContainer);
        $(this).off('ajaxInclude', ajaxIncludeCallback);

        if (_config && _config['debug']) {
            console.warn('ajax included: ', includedContainer);
        }
    }

    return function ($scope) {
        var ajaxIncludeElements = $scope.find('.js-ajaxInclude, [data-append],[data-replace],[data-after],[data-before]');

        ajaxIncludeElements.on('ajaxInclude', function(){
            if (window.picturefillCFG) {
                picturefill();
            }
        });


        var ajaxIncludeOptions = {
            device: matchMedia('(max-width: 767px)').matches ? 'mobile' : 'desktop'
        };

        ajaxIncludeElements.on('ajaxInclude', ajaxIncludeCallback).extendAjaxInclude(ajaxIncludeOptions);

        ajaxIncludeElements.filter('[data-interaction=click]').on('click', function(){
            $(this).removeAttr('data-interaction');
            $(this).on('ajaxInclude', ajaxIncludeCallback).extendAjaxInclude(ajaxIncludeOptions);
        });

    };
}());


/*parsley*/
app.modules.parsley = function ($scope) {
    var parsleyOptions = {
        successClass: 'has-success',
        errorClass: 'has-error',
        classHandler : function( _el ){
            return _el.$element.closest('.form-group');
        },
        errorsContainer: function (_el) {
            return _el.$element.closest('.form-group');
        }
    };

    import('./libs/parsley.min.js').then(function () {

        $scope.find('.js-parsley').parsley(parsleyOptions);

        var $parsleyElements = $scope.find('.js-parsley');
        if ($parsleyElements && $parsleyElements.length) {
            $parsleyElements.parsley().on('field:error', function() {
                var parsleyId = $(this)[0].__id__;
                $(this)[0].$element.attr({
                    'aria-invalid': "true",
                    'aria-describedby': 'parsley-id-'+ parsleyId
                });
            });
            $parsleyElements.parsley().on('field:success', function() {
                $(this)[0].$element.removeAttr('aria-invalid aria-describedby');
            });
        }
    }).catch(function () {
        console.error('parsley loading error');
    });
};


app.modules.isClickable = (function ($scope) {
    function isClickable( obj, newTab ){
        var $this = obj;
        var link = $this.find('a:first');
        var href = link.attr('href');

        if (href == undefined) {
            return;
        }

        var target = link.attr('target');
        if( target == '_blank' || newTab ){
            window.open( href );
        }else{
            window.location.href = href;
        }
    }

    function initScope($scope) {
        if (_config.inEditmode) {
            return;
        }

        $scope.find('.isClickable').on('click', function(evt){

            if (!$(evt.target).is('a') && !$(evt.target).is('button')) {

                if(window.google_tag_manager && app && app.ectracking
                    && $(this).find('a').first().attr('target') !== '_blank' ) {
                    var self = $(this);
                    app.ectracking.productClick(self, function() { isClickable( self ) })
                } else {
                    isClickable($(this));
                }

            } else {

                if(window.google_tag_manager && app && app.ectracking && $(this).attr('target') !== '_blank' ) {
                    var self = $(this);
                    app.ectracking.productClick(self, function() { isClickable( self ) })
                } else {
                    isClickable($(this));
                }
            }

            evt.preventDefault();
        });
    }

    return initScope;
}());


app.modules.slider = function ($scope) {

    var $slider = $scope.find('.js-slider');


    import('./libs/slick.min.js').then(function(){
        var slickOptions = {
            slidesToShow: 1,
            adaptiveHeight: true,
            focusOnSelect: true,
            nextArrow: '<button type="button" class="slick-next slider__arrow-transparent" aria-label="Next"><span class="slider__arrow slick-next"></span></button>',
            prevArrow: '<button type="button" class="slick-prev slider__arrow-transparent" aria-label="Previous"><span class="slider__arrow slick-prev"></span></button>',
            dots: false,
            draggable: true
        };

        $slider.each(function () {
            var $this = $(this),
                options = $.extend({}, slickOptions);

            if ($this.hasClass('js-image-slider')) {
                $.extend(options, {
                    arrows: true,
                    dots: false
                });
            };

            if ($this.hasClass('js-slider-portal')) {
                $.extend(options, {
                    arrows: true,
                    dots: false,
                    autoplay: true,
                    autoplaySpeed: 5000
                });
            };

            if ($this.hasClass('js-xs-package-slider')) {
                $.extend(options, {
                    arrows: false,
                    dots: true,
                    slidesToShow: 1,
                    centerMode: true,
                    centerPadding: '30px'
                });
            }

            $this.slick(options);
        });
    });
};


app.modules.videoJs = function ($scope) {
    app.modules.videoJs.id || (app.modules.videoJs.id = 1);
    import('./libs/video.js').then(function (){
        $scope.find('.js-video-js').each(function () {
            var id = $(this).prop('id');
            if (!id) {
                id = 'video-js-id-' + app.modules.videoJs.id++;
                $(this).prop('id', id);
            }
            videojs(id);

            $scope.find('.js-video-js').on('click', function (evt) {
                $(this).closest('.pimcore_tag_video').addClass('is-playing');
            });
        });
    });
};

import touchNavInit from './scripts/touchNav';
app.touchNav = touchNavInit;

import focusNavInit from './scripts/focusNav';
app.focusNav = focusNavInit;

import mobileNavInit from './scripts/mobileNav';
app.mobileNav = mobileNavInit;

app.modules.lightbox = function ($scope) {

    if (matchMedia('(max-width: 767px)').matches) {
        $scope.find('.js-lightbox__item').on('click', function (evt) {
            evt.preventDefault();
            if($(this).attr('data-src')) {
                window.open($(this).attr('data-src'),'_blank');
            }
        });
    } else {
        import('./libs/lightgallery.min.js').then(function () {

            var lightboxGroups = $scope.find('.js-lightbox');

            lightboxGroups.each(function () {
                $(this).lightGallery({
                    selector: '.js-lightbox__item',
                    download: false,
                    prevHtml: '<span class="lg-inner-prev"></span>',
                    nextHtml: '<span class="lg-inner-next"></span>',
                    iframeMaxWidth: '90%',
                    videoMaxWidth: '90%'
                });
            });

            //prevent isClickable
            $scope.find('.js-lightbox__item').on('click', function (evt) {
                evt.stopImmediatePropagation();
            });
        });
    }

};


app.modules.animateOnScroll = function ($scope) {
    if (matchMedia('(min-width: 768px)').matches) {
        import('./libs/aos.js').then(function () {
            $scope.find('#mainContent .content-block, #mainContent .content-block-small, #mainContent .slide').attr('data-aos','fade-up');

            AOS.init({
                once: true
            });

            $(window).on('load', function() {
                AOS.refresh();
            });
        });
    }
};


app.scrollTopBtn = function () {
    if (window.innerHeight * 2 > document.body.scrollHeight) {
        /*show button only on long pages*/
        return;
    }
    var isHidden = true;
    var $scrollTopBtn = $('.js-scroll-top-btn').on('click', function (evt) {
        evt.preventDefault();
        $('body, html').stop().animate({
            scrollTop: 0
        }, 300 , 'swing');
    });
    $(window).on('scroll', function (evt) {
        if (window.scrollY < 100) {
            if (!isHidden) {
                $scrollTopBtn.removeClass('is-visible');
                isHidden = true;
            }
        } else {
            if (isHidden) {
                $scrollTopBtn.addClass('is-visible');
                isHidden = false;
            }
        }
    });
};

app.modules.gaTracker = function ($scope) {
    $scope.find('.js-gaTracker').on('click', function () {
        var _this = $(this);
        ga('send', 'event', _this.data('ga-category'), _this.data('ga-action'), _this.data('ga-label'));
    });
};

app.modules.scrollTo = (function () {
    function scrollTo ($target, callback) {
        if (!$target || !$target.length) {
            console.warn("Can't scroll to '" + $target + "'. Target element not found");
            return;
        }

        var duration = Math.abs($target.offset().top - window.scrollY) / 8 + 400;

        var offset = $target.offset().top - 55;

        $('html, body').stop().animate({
                scrollTop: offset
            },
            duration,
            'swing', function () {
                if (callback) {
                    callback();
                }
            }
        );
    }

    function focus ($target) {
        if (typeof $target.attr('tabindex') == 'undefined') {
            $target.addClass('hide-focus');
            $target.attr('tabindex', '-1');
        }
        $target.focus();
    }

    return function ($scope) {
        $scope.find('.js-scroll-to').on('click', function (evt) {
            evt.preventDefault();
            var targetSelector = $(this).data('scroll-target') || $(this).attr('href');
            var $target = $(targetSelector);

            switch ($(this).data('toggle')) {
                case 'tab':
                    if ($target.hasClass('in')) {
                        scrollTo($target, function () {
                            focus($target);
                        });
                        evt.stopPropagation();
                        return;
                    }

                    /*scroll to parent because we can't know where the actual child is*/
                    scrollTo($target.parent(), function () {
                        focus($target);
                    });

                    /*update bootstrap nav classes because bootstrap doesn't handle them*/
                    var navTabTrigger = $('.nav [data-toggle="tab"]').filter('[href="' + targetSelector + '"], [data-target="' + targetSelector + '"]');
                    navTabTrigger.each(function () {
                        var $navItems = $(this).closest('.nav').find('li');

                        $navItems.removeClass('active')
                            .find('a').attr('aria-expanded', 'false');

                        $(this).attr('aria-expanded', 'true')
                            .parent().addClass('active');

                    });
                    break;
                case 'collapse':
                    if ($target.hasClass('in')) {
                        scrollTo($target, function () {
                            focus($target);
                        });
                        evt.stopImmediatePropagation();
                        return;
                    }

                    /*scroll to parent because we can't know where the actual child is*/
                    scrollTo($target.parent(), function () {
                        focus($target);
                    });

                    break;
                default:
                    scrollTo($target, function () {
                        focus($target);
                    });
            }
        });
    };
}());

app.modules.actionChanger = function ($scope) {
    $scope.find('.js-action-changer').on('submit', function () {
        var newAction = $(this).data('action');

        if (newAction) {
            $(this).attr('action', newAction);
        } else {
            $(this).attr('action', '');
        }
    });
};



/*app.cookiePermissions = (function(){
    _config.cookieServices || (_config.cookieServices = {});

    var permissionsFormStorage = {};
    try {
        permissionsFormStorage = JSON.parse(localStorage.getItem('cookie-permissions'));
    } catch (e) {}

    var servicePermissions = Object.keys(_config.cookieServices).reduce(function (servicesObject, serviceName) {
        servicesObject[serviceName] = $.extend(
            {}, {
                isAllowed: !!_config.cookieServiceDefault,
                callbacks: []
            },
            _config.cookieServices[serviceName]
        );

        if (permissionsFormStorage && typeof permissionsFormStorage[serviceName] !== 'undefined') {
            servicesObject[serviceName].isAllowed = permissionsFormStorage[serviceName];
        }

        return servicesObject;
    }, {});

    var PIMCORE_TARGETING = 'pimcoreTargeting';
    var PIMCORE_TARGETING_COOKIE_NAME = 'pimcore_targeting_disabled';
    var COOKIE_DELETE_VALUE = '; expires=Thu, 01 Jan 1970 00:00:01 GMT;';

    if (servicePermissions[PIMCORE_TARGETING]) {
        if (hasCookie(PIMCORE_TARGETING_COOKIE_NAME)) {
            let cookieValue = getCookie(PIMCORE_TARGETING_COOKIE_NAME);
            servicePermissions[PIMCORE_TARGETING].isAllowed = !cookieValue;
        } else {
            document.cookie = PIMCORE_TARGETING_COOKIE_NAME + '=' + (servicePermissions[PIMCORE_TARGETING].isAllowed ? COOKIE_DELETE_VALUE : '1');
        }
    }

    if (_config.registerPermissionGrantedCallback) {
        _config.registerPermissionGrantedCallback.forEach(function (obj) {
            registerPermissionGrantedCallback(obj.service, obj.callback);
        });
    }

    function getServicePermission(serviceName) {
        if (typeof servicePermissions[serviceName] === 'undefined') {
            console.warn('getServicePermission of undefined service "' + serviceName + '". ' +
                'Add the service to _config.cookieServices or use one of the existing ones: ',
                Object.keys(servicePermissions)
            );
        }

        return !!servicePermissions[serviceName] && !!servicePermissions[serviceName].isAllowed;
    }*/

    /* callback: passed callback is only called once */
    /*function registerPermissionGrantedCallback(serviceName, callback) {
        if (!serviceName || !callback) {
            console.error('registerPermissionGrantedCallback: wrong arguments serviceName:String, callback:Function');
            return;
        }

        if (getServicePermission(serviceName)) {
            callback();
        } else {
            if (servicePermissions[serviceName] && servicePermissions[serviceName].callbacks) {
                servicePermissions[serviceName].callbacks.push(callback);
            } else {
                console.warn('registerPermissionGrantedCallback of undefined service "' + serviceName + '". ' +
                    'Add the service to _config.cookieServices or use one of the existing ones: ',
                    Object.keys(servicePermissions)
                );
            }
        }
    }

    function setServicePermission(serviceName, isAllowed) {
        servicePermissions[serviceName].isAllowed = isAllowed;
        if (isAllowed) {
            notifyCallbacks(serviceName);
        }

        try {
            var permissionsFormStorage = JSON.parse(localStorage.getItem('cookie-permissions')) || {};

            permissionsFormStorage[serviceName] = isAllowed;

            localStorage.setItem('cookie-permissions', JSON.stringify(permissionsFormStorage));
        } catch (e) {
            console.error(e);
        }

        if (serviceName === PIMCORE_TARGETING) {
            document.cookie = PIMCORE_TARGETING_COOKIE_NAME + '=' + (isAllowed ? COOKIE_DELETE_VALUE : '1');
        }
    }

    function notifyCallbacks(serviceName) {
        if (servicePermissions[serviceName].callbacks) {
            var currentCallback;
            while (currentCallback = servicePermissions[serviceName].callbacks.shift()) {
                currentCallback();
            }
        }
    }

    function acceptAll() {
        Object.keys(servicePermissions).forEach(function (serviceName) {
            setServicePermission(serviceName, true);
        });
    }

    function declineAll() {
        Object.keys(servicePermissions).forEach(function (serviceName) {
            setServicePermission(serviceName, false);
        });
    }*/


    /* modal */
    /*var permissionModal;
    function showModal() {
        if (permissionModal) {
            permissionModal.remove();
        }

        permissionModal = createPermissionModal();
        permissionModal.modal('show');
    }

    function hideModal() {
        if (permissionModal) {
            permissionModal.modal('hide');
        }
    }

    function createPermissionModal() {
        var $modal = $('<div class="cookie-modal modal fade" tabindex="-1" role="dialog" aria-labelledby="permissionModal" aria-hidden="true">' +
            '  <div class="modal-dialog" role="document">' +
            '    <div class="modal-content">' +
            '      <div class="modal-header">' +
            '        <h3 class="modal-title cookie-modal__title" id="permissionModal">' + _config.cookieModal.title + '</h3>' +
            '        <button type="button" class="close" data-dismiss="modal" aria-label="Close">' +
            '          <span aria-hidden="true">&times;</span>' +
            '        </button>' +
            '      </div>' +
            '      <div class="modal-body">' +
            '        ' + createServiceOptions(servicePermissions) +
            '      </div>' +
            '      <div class="modal-footer">' +
            '        <button type="button" class="btn btn-primary js-cookie-modal__save">' + _config.cookieModal.save + '</button>' +
            '      </div>' +
            '    </div>' +
            '  </div>' +
            '</div>');


        var $globalToggle = $modal.find('input[name="all"]');
        var $serviceToggles = $modal.find('input').not($globalToggle);
        $globalToggle.on('change', function () {
            if ($(this).is(':checked')) {
                $serviceToggles.prop('checked', 'checked');
            } else {
                $serviceToggles.prop('checked', null);
            }
        });

        $serviceToggles.on('change', function () {
            $globalToggle.prop('checked', $serviceToggles.not(':checked').length ? null: 'checked');
        });

        $modal.on('click', '.js-cookie-modal__save', function () {
            hideModal();
            $serviceToggles.toArray().forEach(function (input) {
                var serviceName = input.name;
                var isAllowed = $(input).is(':checked');

                setServicePermission(serviceName, isAllowed);
                hideCookieBar();
            });
        });

        $('body').append($modal);
        return $modal;
    }

    function createServiceOptions(services) {
        var options = [];

        options.push('<div class="cookie-modal__item cookie-modal__item--all">' +
            createServiceOption(_config.cookieModal.toggleAll, 'all', areAllServicesAllowed(services)) +
            '</div>');

        options = options.concat(Object.keys(services).map(function (serviceName) {
            return ('<div class="cookie-modal__item">' +
                createServiceOption(services[serviceName].text, serviceName, services[serviceName].isAllowed) +
                createDetailLink(services[serviceName]) +
                '</div>'
            );
        }));

        return options.join('');
    }

    function createServiceOption(label, name, isChecked) {
        return (
            '<label class="cookie-modal__label">' +
            '  <span class="cookie-modal__switch">' +
            '    <input class="sr-only" name="' + name + '" type="checkbox" ' + (isChecked ? 'checked': '') + '>' +
            '    <span class="cookie-modal__switch-toggle"></span>' +
            '  </span>' +
            '  ' + label +
            '</label>'
        );
    }

    function areAllServicesAllowed(services) {
        return Object.keys(services).reduce(function (allAllowed, currentServiceName) {
            return !services[currentServiceName].isAllowed ? false: allAllowed;
        }, true);
    }

    function createDetailLink(service) {
        return (_config.cookieModal.detail && service.url)
            ? '<a class="cookie-modal__link" target="_blank" href="' + service.url + '">' + _config.cookieModal.detail + '</a>'
            : '';
    }*/


    /* cookie bar */
    /*var $cookieBar;
    function createCookieBar() {
        $cookieBar = $('<div class="cookie-bar js-cookie-bar">' +
            '    <div class="cookie-bar__text">' +
            '        ' + _config.cookieBar.text +
            '    </div>' +
            '    <div class="cookie-bar__detail">' +
            '     ' + createCookieBarDetailLink() +
            '     ' + createCookieBarSettingsLink() +
            '    </div>' +
            '    <div class="cookie-bar__buttons">' +
            '        ' + createDeclineButton() +
            '        ' + createAcceptButton() +
            '    </div>' +
            '</div>');

        $('body').append($cookieBar);

        $cookieBar.on('click', '.js-cookie-bar__accept', function () {
            acceptAll();
            hideCookieBar();
        });

        $cookieBar.on('click', '.js-cookie-bar__decline', function () {
            declineAll();
            hideCookieBar();
        });

        $cookieBar.on('click', '.js-cookie-bar__detail', function () {
            showModal();
        });

        return $cookieBar;
    }*/

    /*function createDeclineButton() {
        return _config.cookieBar.decline
            ? '<button type="button" class="cookie-bar__decline btn btn-no-styling js-cookie-bar__decline">' +
            '    ' + _config.cookieBar.decline +
            '</button>'
            : '';
    }
    function createAcceptButton() {
        return _config.cookieBar.accept
            ? '<button type="button" class="cookie-bar__accept btn btn-primary js-cookie-bar__accept">' +
            '    ' + _config.cookieBar.accept +
            '</button>'
            : '';
    }

    function createCookieBarDetailLink() {
        return _config.cookieBar.detail
            ?   '<a target="_blank" href="' + _config.cookieBar.detailUrl +  '" class="cookie-bar__detail-btn btn btn-no-styling">' +
            _config.cookieBar.detail +
            '</a>'
            : '';
    }

    function createCookieBarSettingsLink() {
        return _config.cookieBar.settings && _config.cookieServices && Object.keys(_config.cookieServices).length
            ?   '<button type="button" class="cookie-bar__detail-btn btn btn-no-styling js-cookie-bar__detail">' +
            _config.cookieBar.settings +
            '</button>'
            : '';
    }*/

    /* options.force: if set, force the cookie bar to be shown even if it was already dismissed */
    /*function showCookieBar(options) {
        options = options || [];

        if (options.force) {
            return createCookieBar();
        }

        var showCookieBar = true;
        try {
            showCookieBar = !localStorage.getItem('cookie-bar-dismissed');
        } catch (e) {}

        if (showCookieBar) {
            return createCookieBar();
        }
    }

    function hideCookieBar() {
        if ($cookieBar && $cookieBar.length) {
            $cookieBar.attr('hidden', 'hidden');
        }

        try {
            localStorage.setItem('cookie-bar-dismissed', true);
        } catch (e) {}
    }*/

    /*function getCookie(cname) {
        var name = cname + "=";
        var ca = document.cookie.split(';');
        for(let i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return "";
    }

    function hasCookie(cname) {
        return document.cookie.indexOf(cname) >= 0;
    }*/

    /*return {
        getServicePermission: getServicePermission,
        registerPermissionGrantedCallback: registerPermissionGrantedCallback,
        setServicePermission: setServicePermission,
        showModal: showModal,
        hideModal: hideModal,
       // showCookieBar: showCookieBar,
       // hideCookieBar: hideCookieBar
    };*/

//}());

//app.cookiePermissions.showCookieBar();

app.modules.childCountSelect = function ($scope) {
    $scope.find('.js-childCountSelect').on('keyup input', function () {
        var val = $(this).val();
        var childAgeInputs = $(this).closest('form').find('.js-childAgeInputs .js-child-input');
        childAgeInputs.addClass('hidden').attr( 'required', null );
        if( val == 0 ) {
            $( childAgeInputs).closest( '.js-childAgeContainer').addClass( 'hidden' );
            $('.js-hide-if-childages').removeAttr('hidden');
            $('.mainimg--small .mainimg__headlines').removeAttr('hidden');
        } else {
            $( childAgeInputs).closest( '.js-childAgeContainer').removeClass( 'hidden' );
            $('.js-hide-if-childages').attr('hidden','hidden');
            $('.mainimg--small .mainimg__headlines').attr('hidden','hidden');
        }

        for (var i=0; i < childAgeInputs.length && i < val; i++) {
            childAgeInputs.eq(i).removeClass('hidden').attr( 'required', 'required' );
        }

        var form = $(this).closest('.js-parsley');
        if (form && form.length) {
            form.parsley().destroy();
            app.modules.parsley(form.parent());
        }
    });
};

import loadJQueryUi from '@elements/load-jquery-ui';
app.modules.datepicker = (function () {
    function init($scope) {
        var defaultOptions = {
            minDate: 0,
            nextText: '</span><span class="icon icon-arrow"></span>',
            prevText: '</span><span class="icon icon-arrow"></span>',
            altFormat: '@'
        };

        function addKeyboardSupport($datepicker) {
            function triggerSelect() {
                $('.ui-datepicker-current-day').click();
            }

            $datepicker.on('keydown', function (evt) {
                var newDate = $datepicker.datepicker('getDate');
                if (newDate == null) {
                    $datepicker.datepicker('setDate', new Date());
                    newDate = $datepicker.datepicker('getDate');
                }

                switch (evt.keyCode) {
                    case 37: /*left*/
                        newDate.setDate(newDate.getDate() - 1);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 38: /*up*/
                        newDate.setDate(newDate.getDate() - 7);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 39: /*right*/
                        newDate.setDate(newDate.getDate() + 1);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 40: /*down*/
                        newDate.setDate(newDate.getDate() + 7);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 33: /*page up*/
                        newDate.setDate(newDate.getDate() - 30);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 34: /*page down*/
                        newDate.setDate(newDate.getDate() + 30);
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                    case 13: /*enter*/
                        // selectedDate = newDate;
                        // triggerSelect();
                        $datepicker.datepicker('hide');
                        evt.preventDefault();
                        evt.stopImmediatePropagation();
                        break;
                }

                if (newDate.getTime() != $datepicker.datepicker('getDate').getTime()) {
                    $datepicker.datepicker('setDate', newDate);
                }
            });
        }

        var datePicker = $scope.find('.js-datepicker');
        addKeyboardSupport($(datePicker.filter('[data-date-picker=start]')));

        datePicker.each(function () {
            var $this = $(this);
            var isTimeStringFormat = $this.hasClass('js-datepicker--time-string');
            var options = $.extend({}, defaultOptions);

            if (isTimeStringFormat) {
                options.altFormat = 'yy-mm-ddT00:00:00';
                options.minDate = UTCDateToLocalDate(roundDate(new Date()));
            }

            $this.datepicker(options);

            if ($this.data('min-date')) {
                $this.datepicker("option", "minDate",
                    isTimeStringFormat
                        ? UTCDateToLocalDate(ISOStringToDate($this.data('min-date')))
                        : $this.data('min-date')
                )
            }

            if ($this.data('max-date')) {
                $this.datepicker("option", "maxDate", isTimeStringFormat
                    ? UTCDateToLocalDate(ISOStringToDate($this.data('max-date')))
                    : $this.data('max-date')
                )
            }

            $this.datepicker("option", "altField", $this.data('alt-field'));
        });

        datePicker.filter('[data-date-picker=start]').datepicker('option', 'onClose', function () {
            if ($(this).val().length != 0) {
                var fromDate = $(this).datepicker('getDate');
                // fromDate.setDate(fromDate.getDate() + 1);
                fromDate.setDate(fromDate.getDate());

                var endDatePicker = $(this).closest('form, .form').find('[data-date-picker=end]').eq(0).datepicker('option', 'minDate', fromDate).datepicker('show');
                addKeyboardSupport($(endDatePicker));
            }
        });

    }

    return function ($scope) {
        loadJQueryUi().then(function (a) {
            console.log('on load', $scope, a);
            init($scope);
        });
    }
}());

function isFocusable( $el ) {
    var tabIndex = +$el.attr( "tabindex" );
    tabIndex = isNaN( tabIndex ) ? -1 : tabIndex;
    return $el.is( ":input, a[href], area[href], iframe" ) || tabIndex > -1;
}

/*app.toc*/
(function () {
    var id = 0;
    function addTocEntry (text, anchorId) {
        $tocList.append('<li><a class="sr-only sr-only-focusable" href="#' + anchorId + '">' + text + '</a></li>');
    }

    var $tocList;
    app.toc = function () {

        $tocList = $('.js-toc__list');
        if (!$tocList || !$tocList.length) {
            console.warn('can\'t render Table of content. No js-toc__list found');
        }
    };

    app.modules.toc = function($scope) {
        $scope.find('.js-toc__title').each(function () {
            var $title = $(this);
            var anchorId = 'toc-entry-target-' + id;
            $title.attr('id', 'toc-entry-target-' + id);
            if (!isFocusable($title)) {
                $title.attr('tabindex', '-1');
            }
            id++;
            addTocEntry($title.text(),anchorId);
        });
    }
}());

app.initModules = function ($scope) {
    if(!$scope) {
        $scope = $('body');
    }

    if (_cfg['_preload']) {
        $.each( _cfg['_preload'], function( _key, _val ){
            if( _cfg['_preload'][_key] && app.modules[_key] && typeof window.app.modules[_key] == 'function' ){
                cls.log('init module: ' + _key);
                window.app.modules[_key]($scope);
            }
        });
    }

    //init all modules if the right _cfg key is set for them
    for (var module in _cfg) {
        if (_cfg[module] && app.modules[module] && typeof  app.modules[module] === 'function') {
            cls.log('init module: ' + module);
            app.modules[module]($scope);
        }
    }

    if (_cfg['_reload']) {
        $.each( _cfg['_reload'], function( _key, _val ){
            if( _cfg['_reload'][_key] && app.modules[_key] && typeof window.app.modules[_key] == 'function' ){
                cls.log('init module ' + _key);
                window.app.modules[_key]($scope);
            }
        });
    }

};

import * as ajaxForm from '@elements/ajax-form';
app.modules.demiAjaxForm = ajaxForm.createInitInScope({
        addUrlParams: true,
        fetchHeaders: {'Format':'json'}
    },
    {
        base: '.js-demi-ajax-form',
        result: '.js-demi-ajax-form__result',
        loading: '.js-demi-ajax-form__loading',
        notifications: '.js-demi-ajax-form__notifications',
        errorArea: '.js-demi-ajax-form__error-area',
        additionalForm: '.js-demi-ajax-form__additional-form',
        form: '.js-demi-ajax-form__form',
        link: '.js-demi-ajax-form__link',
        retry: null
    });

import * as datepicker from '@elements/datepicker';
app.modules.demiDatepicker = datepicker.createInitInScope({
    base: '.js-demi-datepicker',
    input: '.js-demi-datepicker__input',
    altField: '.js-demi-datepicker__alt-field'
}, {
    nextText: '</span><span class="icon icon-arrow"></span>',
    prevText: '</span><span class="icon icon-arrow"></span>',
});


(function( $ ){
    "use strict";

    /* -> _config._preload = Load this functions first */
    if (_cfg['_preload']) {
        $.each( _cfg['_preload'], function( _key, _val ){
            if( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ){
                window.app[_key]();
            }
        });
    }

    /* -> _config = Load all others (not _preload and _reload) */
    $.each( _cfg, function( _key, _val ){
        if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' && _key != '_reload' && _key != '_preload' ) ){
            window.app[_key]();
        }
    });

    /* -> _config._reload = Load the ajaxInclued and others after the rest */
    if (_cfg['_reload']) {
        $.each( _cfg['_reload'], function( _key, _val ){
            if( ( typeof _val == 'boolean' && typeof window.app[_key] == 'function' ) ){
                window.app[_key]();
            }
        });
    }

    app.initModules();

})(jQuery);

function dateToISOString(date) {
    if (date) {
        if (date instanceof Date){
            return date.toISOString().substring(0, 19);
        } else {
            console.warn('dateToISOString expects a date, but was given ', date);
        }

    }
}

function ISOStringToDate(dateString) {
    if (dateString) {
        if (typeof dateString === "string") {
            dateString += dateString.includes('Z') ? '' : 'Z';
            return new Date(dateString);
        } else {
            console.warn('ISOStringToDate expects a string, but was given ', date);
        }
    }
}

function localDateToUTCDate(date) {
    if (date){
        if (date instanceof Date){
            return new Date(date.getTime() - (date.getTimezoneOffset() * 60 * 1000));
        } else {
            console.warn('localDateToUTCDate expects a date, but was given ', date);
        }
    }
}

function UTCDateToLocalDate(date) {
    if (date) {
        if (date instanceof Date){
            return new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));
        } else {
            console.warn('UTCDateToLocalDate expects a date, but was given ', date);
        }
    }
}

export function roundDate(date) {
    if (date) {
        // date = new Date(date.getTime() + 60 * 60 * 1000); /*add one hour for potential time changes */
        return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate()));
    }
}
